import React, { useEffect, useState, useMemo } from 'react';
import {
  Box,
  Typography,
  TextField,
  Button
} from '@mui/material';
import { useHistory } from 'react-router-dom';
import CategorySection from './CategorySection';

const videosData = [
  {
    id: '1',
    title: 'React Tutorial',
    description: 'Kom igång med React',
    youtubeUrl: 'https://www.youtube.com/watch?v=Ke90Tje7VS0',
    category: 'Utbildning'
  },
  {
    id: '2',
    title: 'AI Introduktion',
    description: 'Vad är AI och hur fungerar det?',
    youtubeUrl: 'https://www.youtube.com/watch?v=2ePf9rue1Ao',
    category: 'Utbildning'
  },
  {
    id: '3',
    title: 'Produktdemo 2025',
    description: 'Visa ny funktion',
    youtubeUrl: 'https://www.youtube.com/watch?v=ysz5S6PUM-U',
    category: 'Marknadsföring'
  },
  {
    id: '4',
    title: 'Javascript i praktiken',
    description: 'Exempel på JS-funktioner',
    youtubeUrl: 'https://www.youtube.com/watch?v=PkZNo7MFNFg',
    category: 'Utbildning'
  },
  {
    id: '5',
    title: 'Vår nya kampanjvideo',
    description: 'Marknadsföringsfilm 2024',
    youtubeUrl: 'https://www.youtube.com/watch?v=aqz-KE-bpKQ',
    category: 'Marknadsföring'
  }
];

export default function VideoPage() {
  const [videos, setVideos] = useState([]);
  const [search, setSearch] = useState('');
  const history = useHistory();

  useEffect(() => {
    setVideos(videosData);
  }, []);

  const filteredVideos = useMemo(() => {
    return videos.filter(v =>
      v.title.toLowerCase().includes(search.toLowerCase()) ||
      v.description.toLowerCase().includes(search.toLowerCase())
    );
  }, [search, videos]);

  const categories = [...new Set(filteredVideos.map(v => v.category))];

  return (
    <Box sx={{ backgroundColor: '#fff', color: '#333', minHeight: '100vh', p: 3 }}>
      {/* Tillbaka-knapp */}
      {/*<Box sx={{ mb: 3 }}>*/}
      {/*  <Button variant="outlined" onClick={() => history.push('/')}>*/}
      {/*    ← Tillbaka till hjälpcenter*/}
      {/*  </Button>*/}
      {/*</Box>*/}

      <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 1 }}>
        Videohandledningar
      </Typography>
      <Typography variant="body1" sx={{ color: '#555', mb: 4 }}>
        <strong>Se UniQueue i praktiken</strong> – Titta på korta, inspirerande videor som visar hur du snabbt kommer igång och arbetar effektivt.
      </Typography>

      <TextField
        fullWidth
        variant="outlined"
        placeholder="Sök videor..."
        value={search}
        onChange={e => setSearch(e.target.value)}
        sx={{ mb: 4 }}
      />

      {categories.map(category => (
        <CategorySection
          key={category}
          title={category}
          videos={filteredVideos.filter(v => v.category === category)}
        />
      ))}
    </Box>
  );
}
